import {
  useListUsersByOrganization,
  useListOrganizations,
  useListRolesByOrganization,
} from 'api/resource';
import { User, Organization, Role } from 'interfaces';
import { useCurrentUserStore } from 'store/UserStore';

export const useUserManagementData = () => {
  const { organizationID } = useCurrentUserStore();

  const {
    data: users = [] as User[],
    isLoading: loadingUsers,
    isError: userError,
    error: userErrorData,
  } = useListUsersByOrganization({ orgID: organizationID });

  const {
    data: organizations = [] as Organization[],
    isError: organizationError,
    isLoading: loadingOrganizations,
    error: organizationErrorData,
  } = useListOrganizations({ isAdmin: false, organizationID });

  const {
    data: roles = [] as Role[],
    isError: roleError,
    isLoading: loadingRoles,
    error: roleErrorData,
  } = useListRolesByOrganization({ organizationID });

  const isLoading = loadingUsers || loadingOrganizations || loadingRoles;
  const isError = userError || organizationError || roleError;

  const errorMessage =
    userErrorData?.message ||
    organizationErrorData?.message ||
    roleErrorData?.message;

  return {
    users,
    organizations,
    roles,
    isLoading,
    isError,
    errorMessage,
  };
};
